/** Full recent-searches list (shell route `/recent-searches`): all entries the hook loaded, remove + clear all. */
import React from 'react';
import { SEARCH_HISTORY_LIMIT, useSearchHistory } from '../hooks/useSearchHistory';
import { SearchHistoryRow } from '../shell/home/SearchHistoryRow';
import { relativeTime } from '../utils/describeSearch';
import { replayPath } from '../utils/searchNav';

const CLEAR_CONFIRM = 'Delete your entire search history? This also deletes searches not shown on this page.';

const RecentSearchesPage: React.FC = () => {
  const { history: entries, isLoading, removeSearch, clearHistory } = useSearchHistory();
  return (
    <div data-testid="recent-searches-page" className="mx-auto w-full max-w-3xl p-8">
      <div className="flex items-baseline justify-between gap-4">
        <h1 className="font-display text-[28px] font-medium tracking-[-0.02em] text-ink">Recent searches</h1>
        {entries.length > 0 && (
          <button
            type="button"
            data-testid="recent-clear-all"
            className="text-[13px] text-accent hover:underline"
            onClick={() => { if (window.confirm(CLEAR_CONFIRM)) clearHistory(); }}
          >
            Clear all
          </button>
        )}
      </div>
      {!isLoading && entries.length === SEARCH_HISTORY_LIMIT && (
        <p className="mt-1 text-[12px] text-ink-3">{`Showing your latest ${SEARCH_HISTORY_LIMIT}`}</p>
      )}
      {!isLoading && entries.length === 0 && <p className="mt-4 text-[13px] text-ink-3">No searches yet.</p>}
      <div className="mt-4">
        {entries.map((e) => (
          <SearchHistoryRow
            key={e.id}
            entry={e}
            to={replayPath(e)}
            replace={false}
            meta={relativeTime(e.created_at)}
            trailing={
              <button
                type="button"
                aria-label="Remove search"
                data-testid={`recent-remove-${e.id}`}
                className="text-ink-3 hover:text-ink"
                onClick={() => removeSearch(e.id)}
              >
                <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default RecentSearchesPage;
